import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { Button, Divider, Tabs } from 'antd'
import MainLayout from 'Hoc/MainLayout'
import AgreementTable from 'Components/AgreementTable'
//import PurposeTable from 'Components/PurposeTable'
import AgreementTableFilter from 'Components/AgreementTableFilter'
import PurposeTableFilter from 'Components/PurposeTableFilter'
import Loader from 'Components/Loader'
import * as _ from 'lodash'

import api from 'Common/api'
import { agreementState, purposeState, userType } from 'Common/constants'
import { isEmptyObject } from 'Common/utils'

import { connect } from 'react-redux'
import {
  resetSelectedAgreement,
  resetSelectedRefs,
  updateAgreementsList,
  updateAgreementTableSort,
  updateSelectedAgreement,
  updateSelectedRefs
} from 'Actions/agreement-actions'
import { getStatesBasedOnUserType } from '../../common/utils'
import { setStores, setSuppliers } from '../../redux-store/actions/data-actions'
import { resetSelectedPurpose, updatePurposesList, updateSelectedPurpose } from 'Actions/purpose-actions'
import { updateAgreementFilters, updatePurposeFilters } from 'Actions/filter-actions'
import { updateUser } from '../../redux-store/actions/user-actions'
import * as queryString from 'qs'
import MidMsgComponent from '../../components/MidMsg'
import MiddleCenter from 'Hoc/MiddleCenter'

class Dashboard extends Component {
  state = {
    tableLoading: false,
    viewAgreementLoading: { loading: false, id: null },
    viewPurposeLoading: { loading: false, id: null },
    agreementStates: [],
    purposeStates: [],
    canProceed: false,
    isAuthenticating: true
  }

  authenticate() {
    const qs = queryString.parse(_.get(this.props, ['location', 'search'], '').replace('?', ''));

    if (_.has(qs, 'stoken')) {
      sessionStorage.setItem('token', qs.stoken);
      this.props.history.replace('/');
    }

    if (_.has(qs, 'token')) {
      api.auth.getToken(qs.token).then(response => {
        const token = response.data.token;
        sessionStorage.setItem('token', token);
        api.auth.decode().then(response => {
          window.backendApplicationVersion = response.data.applicationVersion ?
            response.data.applicationVersion : window.backendApplicationVersion ?
              window.backendApplicationVersion : null;
          this.props.updateUser({ data: response.data, type: response.data.userType });
        }).catch(err => {
          console.error(err);
          this.props.updateUser({ data: null, type: null });
        }).finally(() => {
          this.props.history.replace('/');
          this.setState({ isAuthenticating: false });
        })
      }).catch(err => {
        sessionStorage.removeItem('token');
        console.error(err);
        this.setState({ isAuthenticating: false });
      });
    } else if (sessionStorage.getItem('token') !== null) {
      api.auth.decode().then(response => {
        window.backendApplicationVersion = response.data.applicationVersion ?
          response.data.applicationVersion : window.backendApplicationVersion ?
            window.backendApplicationVersion : null;
        this.props.updateUser({ data: response.data, type: response.data.userType });
      }).catch(err => {
        console.error(err);
        this.props.updateUser({ data: null, type: null });
      }).finally(() => {
        this.setState({ isAuthenticating: false });
      })
    } else {
      this.setState({ isAuthenticating: false });
    }

    // const jwtData = getCookie('jwt');
    //
    // if (jwtData !== null) {
    //   api.auth.getToken(jwtData, userType.S.key).then(response => {
    //     const token = response.data.token;
    //     sessionStorage.setItem('token', token);
    //     api.auth.decode().then(response => {
    //       window.backendApplicationVersion = response.data.applicationVersion ?
    //           response.data.applicationVersion : window.backendApplicationVersion ?
    //             window.backendApplicationVersion : null;
    //       this.props.updateUser({data: response.data, type: response.data.userType});
    //     }).catch(err => {
    //       console.error(err);
    //       this.props.updateUser({data: null, type: null});
    //     });
    //   }).catch(err => {
    //     sessionStorage.removeItem('token');
    //     console.error(err);
    //   });
    // }
  }

  fetchData() {
    const currentUserType = _.get(this.props.user, 'type', null);

    switch (currentUserType) {
      case userType.PM.key:
        this.fetchAgreements();
        this.fetchAgreementStates();
        break;
      case userType.S.key:
      case userType.AM.key:
      case userType.SC.key:
        this.fetchAgreements();
        this.fetchAgreementStates();
        this.fetchPurposes();
        this.fetchPurposeStates();
        break;
      case userType.FIN.key:
        this.fetchAgreements();
        this.fetchAgreementStates();
        this.fetchPurposes();
        this.fetchPurposeStates();
        this.fetchStores();
        break;
      default:
    }
  }

  componentDidMount() {
    this.authenticate();
    this.fetchData();

    // Clear selected agreement and refs on Redux store, if not empty
    if (!isEmptyObject(this.props.selectedAgreement)) {
      this.props.resetSelectedAgreement()
      this.props.resetSelectedRefs()
    }

    this.viewAgreement = this.viewAgreement.bind(this);
  }

  componentDidUpdate(prevProps) {
    // On filter change, fetch filtered agreements
    if (prevProps.filterAgreement !== this.props.filterAgreement) {
      this.fetchAgreements(this.props.filterAgreement)
    }

    if (prevProps.user !== this.props.user) {
      this.fetchData();

      // Clear selected agreement and refs on Redux store, if not empty
      if (!isEmptyObject(this.props.selectedAgreement)) {
        this.props.resetSelectedAgreement()
        this.props.resetSelectedRefs()
      }
    }

    if (prevProps.filterPurpose !== this.props.filterPurpose) {
      this.fetchPurposes(this.props.filterPurpose)
    }
  }

  saveAgreementFilters = value => {
    // Save selected filters on Redux store
    this.props.updateAgreementFilters(value)
  }

  savePurposeFilters = value => {
    // Save selected filters on Redux store
    this.props.updatePurposeFilters(value)
  }

  handleTableAgreementChange = (pagination, filters, sorter) => {
    // Save selected sorting on Redux store
    this.props.updateAgreementTableSort({
      key: sorter.columnKey,
      direction: sorter.order
    })
    // Replace "descend" with "desc" or "ascend" with "asc"
    const sortDirection = sorter.order && sorter.order.replace(/end/, '')
    // Set params (pagination and sorting) before fetching sorted agreements
    const params = {
      numPage: pagination.current > 1 ? pagination.current - 1 : undefined,
      sort:
        sorter.columnKey && sortDirection
          ? `${sorter.columnKey},${sortDirection}`
          : undefined
    }
    // Fetch sorted agreements
    this.fetchAgreements(params)
  }

  handleTablePurposeChange = (pagination, filters, sorter) => {
    // Save selected sorting on Redux store
    this.props.updateAgreementTableSort({
      key: sorter.columnKey,
      direction: sorter.order
    })
    // Replace "descend" with "desc" or "ascend" with "asc"
    const sortDirection = sorter.order && sorter.order.replace(/end/, '')
    // Set params (pagination and sorting) before fetching sorted agreements
    const params = {
      numPage: pagination.current > 1 ? pagination.current - 1 : undefined,
      sort:
        sorter.columnKey && sortDirection
          ? `${sorter.columnKey},${sortDirection}`
          : undefined
    }
    // Fetch sorted agreements
    this.fetchPurposes(params)
  }

  fetchAgreementStates = () => {
    // Axios GET call, fetch agreement states
    api.domains.getAgreementState().then(res => {
      const states = [];
      Object.keys(res.data).forEach((state, i) => {
        if (typeof agreementState[state] !== 'undefined') {
          states.push({
            key: agreementState[state].key,
            label: agreementState[state].label
          });
        }
      })
      // Save agreement states in component state
      this.setState({ agreementStates: states })
    })
  }

  fetchPurposeStates = () => {
    // Axios GET call, fetch purpose states
    api.domains.getPurposeState({ isDirect: true }).then(res => {
      const states = [];
      Object.keys(res.data).forEach((state, i) => {
        if (typeof purposeState[state] !== 'undefined') {
          states.push({
            key: purposeState[state].key,
            label: purposeState[state].label
          });
        }
      })
      // Save purpose states in component state
      this.setState({ purposeStates: states })
    }).catch(err => {
      console.error(err)
      //TODO: remove setState when the api call will be implemented
      const states = Object.keys(purposeState).map((state, i) => {
        return {
          key: purposeState[state].key,
          label: purposeState[state].label
        }
      })
      this.setState({ purposeStates: states })
    })
  }

  fetchAgreements = (params = {}) => {
    // Loading while fetching
    this.setState({ tableLoading: true })
    // If filters exist, add to params before fetching
    params = !isEmptyObject(this.props.filterAgreement)
      ? { ...params, ...this.props.filterAgreement }
      : params
    // Axios GET call, fetch agreements

    params.tab = 'AGREEMENT'

    if (_.has(this.props, ['user', 'type']) && !_.has(params, 'state')) {
      _.set(params, 'state', getStatesBasedOnUserType(this.props.user.type));
    } else if (!_.has(params, 'state')) {
      _.set(params, 'state', getStatesBasedOnUserType('UNKNOWN'));
    }

    api.agreements
      .getAll(params)
      .then(res => {
        // Set table pagination
        const tableAgreementPagination = {
          current: res.data.number + 1,
          total: res.data.totalElements
        }
        // Save results on Redux store
        this.props.updateAgreementsList(res.data.content)
        // Stop loading & set table pagination
        this.setState({ tableLoading: false, tableAgreementPagination })
      })
      .catch(err => {
        console.error(err)
        const tableAgreementPagination = {
          current: 0,
          total: 0
        }
        // Stop loading
        this.setState({ tableLoading: false, tableAgreementPagination })
        this.props.updateAgreementsList([]);
      })
  }

  fetchPurposes = params => {
    // Loading while fetching
    this.setState({ tableLoading: true })
    // If filters exist, add to params before fetching
    params = !isEmptyObject(this.props.filterPurpose)
      ? { ...params, ...this.props.filterPurpose }
      : { ...params }

    params.tab = 'PROPOSAL'

    // Axios GET call, fetch purposes
    api.agreements
      .getAll(params)
      .then(res => {
        // Set table pagination
        const tablePurposePagination = {
          current: res.data.number + 1,
          total: res.data.totalElements
        }
        // Save results on Redux store
        this.props.updatePurposesList(res.data.content)
        // Stop loading & set table pagination
        this.setState({ tableLoading: false, tablePurposePagination })
      })
      .catch(err => {
        console.error(err)
        // Stop loading
        this.setState({
          tableLoading: false,
          current: 1,
          total: 0
        });
        this.props.updatePurposesList([]);
      })
  }

  fetchStores = () => {
    // Axios GET call, fetch all stores
    api.stores.getAll().then(res => {
      // this.setState({ stores: res.data.stores })
      this.props.setStores(res.data.stores)
    })
  }

  viewAgreement = (id, tab) => {
    // Loading while fetching
    this.setState({ viewAgreementLoading: { loading: true, id } })
    // Axios GET call, fetch a single agreement passing the id

    let params = {}

    if (tab === "agreements") {
      params = {
        storeId: this.props.filterAgreement.storeId,
        ddt: this.props.filterAgreement.ddt ? this.props.filterAgreement.ddt : null,
        bds: this.props.filterAgreement.bds ? this.props.filterAgreement.bds : null
      }
    }

    api.agreements
      .getOne(id, params)
      .then(res => {
        // Stop loading
        this.setState({ viewAgreementLoading: { loading: false, id: null } })

        // Save result on Redux store
        this.props.updateSelectedAgreement(res.data)
        this.props.updateSelectedRefs(res.data.agreementDetails)
        // Navigate to the agreement view page
        this.props.history.push(`/view/${id}`)
      })
      .catch(err => {
        console.error(err)
        // Stop loading
        this.setState({ viewAgreementLoading: { loading: false, id: null } })
      })
  }

  viewPurpose = id => {
    // Loading while fetching
    this.setState({ viewPurposeLoading: { loading: true, id } })
    // Axios GET call, fetch a single agreement passing the id
    api.purposes
      .getOne(id)
      .then(res => {
        // Stop loading
        this.setState({ viewPurposeLoading: { loading: false, id: null } })

        // Save result on Redux store
        this.props.updateSelectedPurpose(res.data)
        this.props.updateSelectedRefs(res.data.agreementDetails)
        // Navigate to the agreement view page
        this.props.history.push(`/view/${id}`)
      })
      .catch(err => {
        console.error(err)
        // Stop loading
        this.setState({ viewPurposeLoading: { loading: false, id: null } })
      })
  }

  render() {
    if (this.state.isAuthenticating) {
      return <MiddleCenter>
        <Loader />
      </MiddleCenter>
    }

    if (this.props.user.type === null) {
      return <MidMsgComponent title={'PAGINA NON ACCESSIBILE'} description={'L\'applicazione è accessibile soltanto attraverso i canali di autenticazione.'} />
    }

    const {
      tableLoading,
      viewAgreementLoading,
      viewPurposeLoading,
      agreementStates,
      purposeStates,
      tableAgreementPagination,
      tablePurposePagination
    } = this.state
    const { agreementsList, purposesList, filterAgreement, filterPurpose, sortAgreement, sortPurpose, user } = this.props
    return (
      <MainLayout>
        {/* Show button only if user is PM */}
        {user.type === userType.PM.key && (
          <Fragment>
            <Link to="/new">
              <Button icon="plus" type="primary">
                Nuovo accordo
              </Button>
            </Link>
            <Divider />
          </Fragment>
        )}
        {user.type === userType.AM.key && (
          <Fragment>
            <Link to="/new-proposal">
              <Button icon="plus" type="primary">
                Nuova proposta
              </Button>
            </Link>
            <Divider />
          </Fragment>
        )}
        <Tabs size="large">
          {[userType.AM.key, userType.SC.key, userType.PM.key, userType.S.key, userType.FIN.key].indexOf(user.type) > -1 &&
            <Tabs.TabPane tab="Accordi" key="a">
              <AgreementTableFilter
                user={user}
                stores={this.props.stores}
                suppliers={this.props.suppliers}
                filter={filterAgreement}
                states={agreementStates}
                onChangeCallback={this.saveAgreementFilters}
              />
              {tableLoading ? <Loader /> : <AgreementTable
                tab="agreements"
                loading={viewAgreementLoading}
                agreementsList={agreementsList}
                viewAgreementCallback={this.viewAgreement}
                onChangeCallback={this.handleTableAgreementChange}
                pagination={tableAgreementPagination}
                sort={sortAgreement}
                user={user}
              />}
            </Tabs.TabPane>}
          {/*{[userType.PM.key, userType.FIN.key, userType.AM.key, userType.S.key].indexOf(user.type) > -1 &&*/}
          {/*<Tabs.TabPane tab={user.type === userType.AM.key ? 'Proposte' : 'Accordi'}  key="b">*/}
          {/*  <AgreementTableFilter*/}
          {/*    user={user}*/}
          {/*    suppliers={this.props.suppliers}*/}
          {/*    filter={filterAgreement}*/}
          {/*    states={agreementStates}*/}
          {/*    onChangeCallback={this.saveAgreementFilters}*/}
          {/*  />*/}
          {/*  {tableLoading ? <Loader /> : <AgreementTable*/}
          {/*    loading={viewAgreementLoading}*/}
          {/*    agreementsList={purposesList}*/}
          {/*    viewAgreementCallback={this.viewAgreement}*/}
          {/*    onChangeCallback={this.handleTableAgreementChange}*/}
          {/*    pagination={tableAgreementPagination}*/}
          {/*    sort={sortAgreement}*/}
          {/*    user={user}*/}
          {/*  />}*/}
          {/*</Tabs.TabPane>}*/}

          {[userType.SC.key, userType.S.key, userType.AM.key, userType.FIN.key].indexOf(user.type) > -1 &&
            <Tabs.TabPane tab={'Proposte'} key="b">
              <PurposeTableFilter
                user={user}
                stores={this.props.stores}
                suppliers={this.props.suppliers}
                filter={filterPurpose}
                states={purposeStates}
                onChangeCallback={this.savePurposeFilters}
              />
              {tableLoading ? <Loader /> : <AgreementTable
                tab="proposals"
                loading={viewPurposeLoading}
                agreementsList={purposesList}
                viewAgreementCallback={this.viewAgreement}
                onChangeCallback={this.handleTablePurposeChange}
                pagination={tablePurposePagination}
                sort={sortPurpose}
                user={user}
              />}
            </Tabs.TabPane>}

        </Tabs>
        {/*{user.type !== userType.AM.key && user.type !== userType.SC.key ?*/}
        {/*<AgreementTableFilter*/}
        {/*user={user}*/}
        {/*suppliers={this.props.suppliers}*/}
        {/*filter={filterAgreement}*/}
        {/*states={agreementStates}*/}
        {/*onChangeCallback={this.saveAgreementFilters}*/}
        {/*/>*/}
        {/*:*/}

        {/*}*/}

        {/*{tableLoading ? (*/}
        {/*<Loader />*/}
        {/*) : (*/}
        {/*user.type !== userType.AM.key && user.type !== userType.SC.key ?*/}
        {/*<AgreementTable*/}
        {/*loading={viewAgreementLoading}*/}
        {/*agreementsList={agreementsList}*/}
        {/*viewAgreementCallback={this.viewAgreement}*/}
        {/*onChangeCallback={this.handleTableAgreementChange}*/}
        {/*pagination={tableAgreementPagination}*/}
        {/*sort={sortAgreement}*/}
        {/*user={user}*/}
        {/*/>*/}
        {/*  :*/}
        {/*)}*/}
      </MainLayout>
    )
  }
}

const mapStateToProps = state => {
  return {
    agreementsList: state.Agreement.agreementsList,
    purposesList: state.Purpose.purposesList,
    selectedAgreement: state.Agreement.selectedAgreement,
    filterAgreement: state.Filter.agreement,
    sortAgreement: state.Agreement.agreementTableSort,
    user: state.User,
    stores: state.Data.stores,
    suppliers: state.Data.suppliers,
    selectedPurpose: state.Purpose.selectedPurpose,
    filterPurpose: state.Filter.purpose,
    sortPurpose: state.Purpose.purposeTableSort
  }
}

const mapDispatchToProps = {
  updateAgreementsList,
  updateSelectedAgreement,
  resetSelectedAgreement,
  updateSelectedRefs,
  resetSelectedRefs,
  updateAgreementFilters,
  updateAgreementTableSort,
  setStores,
  setSuppliers,
  updatePurposeFilters,
  updatePurposesList,
  updateSelectedPurpose,
  resetSelectedPurpose,
  updateUser
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard)



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js